import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

interface VehiclePanelProps {
  vehicles: Record<string, unknown>[];
}

export function VehiclePanel({ vehicles }: VehiclePanelProps) {
  useQuery({
    queryKey: ['vehicle-stats'],
    queryFn: () => api.getVehicles(),
  });

  return (
    <div className="space-y-6">
      {/* Stats Overview */}
      <div className="grid grid-cols-4 gap-4">
        <div className="card text-center">
          <div className="text-2xl font-bold text-mars-400">
            {vehicles.length}
          </div>
          <div className="text-xs text-lunar-300">Total Vehicles</div>
        </div>
        <div className="card text-center">
          <div className="text-2xl font-bold text-mars-400">
            {vehicles.filter(v => (v.passenger_count as number) > 0).length}
          </div>
          <div className="text-xs text-lunar-300">Active</div>
        </div>
        <div className="card text-center">
          <div className="text-2xl font-bold text-mars-400">
            {vehicles.reduce((sum, v) => sum + (v.passenger_count as number || 0), 0)}
          </div>
          <div className="text-xs text-lunar-300">Passengers</div>
        </div>
        <div className="card text-center">
          <div className="text-2xl font-bold text-mars-400">
            {vehicles.length > 0 
              ? Math.round(vehicles.reduce((sum, v) => sum + (v.speed as number || 0), 0) / vehicles.length)
              : 0}
          </div>
          <div className="text-xs text-lunar-300">Avg Speed</div>
        </div>
      </div>

      {/* Vehicle List */}
      <div className="card">
        <h2 className="text-lg font-bold mb-4">🚗 Vehicle Fleet</h2>
        <div className="space-y-3">
          {vehicles.map(vehicle => (
            <div 
              key={vehicle.id as number} 
              className={`flex items-center justify-between bg-lunar-700 rounded-lg p-3 ${
                (vehicle.passenger_count as number) > 0 ? 'border-l-2 border-mars-400' : ''
              }`}
            >
              <div className="flex items-center gap-3">
                <div className="text-2xl">
                  {vehicle.type === 'rover' ? '🚙' : 
                   vehicle.type === 'shuttle' ? '🚀' : '🚗'}
                </div>
                <div>
                  <div className="font-medium">{vehicle.name as string}</div>
                  <div className="text-xs text-lunar-400">
                    📍 {vehicle.location_name as string || `Location ${vehicle.current_location_id}`}
                  </div>
                </div>
              </div>
              
              <div className="text-right">
                <div className="text-sm">
                  {(vehicle.passenger_count as number) > 0 ? (
                    <span className="text-mars-400">
                      👥 {vehicle.passenger_count as number} passengers
                    </span>
                  ) : (
                    <span className="text-lunar-400">Idle</span>
                  )}
                </div>
                <div className="text-xs text-lunar-400">
                  ⚡ Speed: {vehicle.speed as number}
                </div>
              </div>
            </div>
          ))}
          
          {vehicles.length === 0 && (
            <div className="text-center text-lunar-400 py-8">
              No vehicles in the colony
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
